import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "../components/site/PageHero";
import { api, fileUrl, formatDate } from "../lib/api";

export default function NewsDetail() {
  const { slug } = useParams();
  const { data, isLoading, isError } = useQuery({ queryKey: ["news-item", slug], queryFn: () => api.get(`/news/${slug}`).then((r) => r.data) });
  usePageMeta(data?.title || "News", data?.summary);
  return (
    <article className="py-14 md:py-20" data-testid="news-detail">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Link to="/news" className="inline-flex items-center gap-1 text-sm font-semibold text-royal" data-testid="news-back-link"><ArrowLeft className="h-4 w-4" /> All news</Link>
        {isLoading && <p className="mt-10 text-slate-500">Loading…</p>}
        {isError && <p className="mt-10 text-slate-500" data-testid="news-not-found">This article could not be found.</p>}
        {data && (
          <>
            <span className="mt-8 inline-block rounded-full bg-royal-light px-3 py-1 text-xs font-semibold text-royal">{data.category}</span>
            <h1 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-testid="news-detail-title">{data.title}</h1>
            <p className="mt-3 text-sm text-slate-500">{formatDate(data.published_at)}</p>
            {data.image_file_id && <img src={fileUrl(data.image_file_id)} alt={data.title} className="mt-8 w-full rounded-2xl object-cover" />}
            <p className="mt-8 text-lg font-medium text-slate-700">{data.summary}</p>
            <div className="prose-itef mt-6">{data.body.split(/\n+/).map((p, i) => <p key={i}>{p}</p>)}</div>
          </>
        )}
      </div>
    </article>
  );
}
